import { NgModule, NgModuleFactoryLoader, SystemJsNgModuleLoader, ModuleWithProviders, Provider } from '@angular/core';
import { NgxCmHelperLibComponent } from './ngx-cm-helper-lib.component';
import { NgxCmFiltersModule } from './ngx-cm-filters/ngx-cm-filters.module';
import { NgxCmComponentsModule } from './ngx-cm-components/ngx-cm-components.module';
import { NgxComponentService } from './ngx-cm-services/ngx-component.service';
import { NgxCmModuleInfo, NGXCMModuleConfig } from './models';
import { provideRoutes } from '@angular/router';
import { NGX_CM_MODULE_LOADER_REGISTRY, NGX_CM_MODULE_CONFIG, NGX_CM_AUTH_PROVIDER } from './_internals';
import { NgxModalContainerComponent } from './ngx-cm-components/ngx-modal-container/ngx-modal-container.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgxCmInterceptorService } from './ngx-cm-services/ngx-cm-interceptor.service';
import { NgxCmAuthProvider } from './models/ngx-auth-provider';
import { NgxCmTokenService } from './ngx-cm-services/ngx-cm-token.service';
import { NgxComponentInternalService } from './ngx-cm-services/ngx-component.internal.service';

export function noMatch() {
  return null;
}

@NgModule({
  declarations: [NgxCmHelperLibComponent],
  imports: [
    NgxCmFiltersModule, NgxCmComponentsModule
  ],
  exports: [NgxCmHelperLibComponent, NgxCmFiltersModule, NgxCmComponentsModule],
  providers: [
    provideRoutes([])
  ],
  entryComponents: [NgxModalContainerComponent]
})
export class NgxCmHelperLibModule {
  static forRoot(config?: NGXCMModuleConfig, authClass?: NgxCmAuthProvider, moduleInfo?: NgxCmModuleInfo[]) {
    const providersList: Array<any> = [
      NgxComponentService,
      NgxComponentInternalService,
      {
        provide: NgModuleFactoryLoader,
        useClass: SystemJsNgModuleLoader
      }
    ];

    if (config) {
      providersList.push({
        provide: NGX_CM_MODULE_CONFIG,
        useValue: config,
        multi: true
      });
    }

    if (authClass) {
      providersList.push(
        {
          provide: NGX_CM_AUTH_PROVIDER,
          useClass: authClass
        }
      );
      providersList.push(
        NgxCmTokenService
      );
      providersList.push(
        {
          provide: HTTP_INTERCEPTORS,
          useClass: NgxCmInterceptorService,
          multi: true
        }
      );
    }

    if (moduleInfo) {
      providersList.push(
        provideRoutes(moduleInfo.map(module => ({ loadChildren: module.loadChildren, matcher: noMatch })))
      );
      providersList.push(
        {
          provide: NGX_CM_MODULE_LOADER_REGISTRY,
          useValue: moduleInfo
        }
      );
    }

    return {
      ngModule: NgxCmHelperLibModule,
      providers: providersList
    };
  }
}
